import React from "react";
import { connect } from "react-redux";
import moment from "moment";
import { Form } from "react-bootstrap";
import { css } from "aphrodite";
import styles from "./style";

class SideDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  renderGender = (gender) => {
    if (gender) {
      if (gender === "M") return "Male";
      else return "Female";
    } else {
      return "-";
    }
  };

  calculateAge = (dob) => {
    var today = new Date();
    var birthDate = new Date(dob); // create a date object directly from `dob1` argument
    var age_now = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age_now--;
    }
    //console.log("age_now....", age_now);
    return age_now;
  };

  render() {
    const { profileData, profileImage } = this.props;
    return (
      <div
        style={{
          padding: "1em",
        }}
      >
        <div className={css(styles.header)}>
          <img
            alt="avatar"
            src={profileImage !== null
            ? profileImage
            : "/images/user-flat.png"}
            className={css(styles.avatar)}
          />
          <div className={css(styles.name)}>
            {`${profileData.patientData.firstName} ${profileData.patientData.lastName}`}

            <div className={css(styles.role)}>{profileData.diseaseConditions[0].name}</div>
            {/* <div className={css(styles.last)}>
                Last login:{" "}
                {moment(this.props.user.lastLoggedIn).format(
                  "MMM Do, YYYY, h:mm A"
                )}
              </div> */}
          </div>
        </div>

        <div>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label className={css(styles.labels)}>AGE</Form.Label>
              <div
                style={{
                  borderBottom: "1px solid #ccc",
                }}
              >
                <Form.Text className={css(styles.valueLabels)}>
                  {`${this.calculateAge(profileData.patientData.dob)} Yrs`}
                </Form.Text>
              </div>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label className={css(styles.labels)}>GENDER</Form.Label>
              <div
                style={{
                  borderBottom: "1px solid #ccc",
                }}
              >
                <Form.Text className={css(styles.valueLabels)}>
                  {this.renderGender(profileData.patientData.gender)}
                </Form.Text>
              </div>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label className={css(styles.labels)}>ZIP CODE</Form.Label>
              <div
                style={{
                  borderBottom: "1px solid #ccc",
                }}
              >
                <Form.Text className={css(styles.valueLabels)}>
                  {profileData.patientData.zipCode}
                </Form.Text>
              </div>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label className={css(styles.labels)}>
                Monitoring Condition
              </Form.Label>
              <div
                style={{
                  borderBottom: "1px solid #ccc",
                }}
              >
                <Form.Text className={css(styles.valueLabels)}>
                  {profileData.diseaseConditions[0].name}
                </Form.Text>
              </div>
            </Form.Group>
          </Form>
        </div>
      </div>
    );
  }
}

export default connect(
  (store) => {
    return {
      profileData: store.dashboard.profileData,
      profileImage: store.dashboard.profileImage,
    };
  },
  (dispatch) => {
    return {};
  }
)(SideDetails);
